// extracted by mini-css-extract-plugin
export default {"orDivider":"styles_orDivider__mZuFJ"};